/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type InvitationTypeEnum = "account" | "workspace" | "%future added value";
export type InvitationAcceptanceFormTokenValidityQueryVariables = {
    token: string;
};
export type InvitationAcceptanceFormTokenValidityQueryResponse = {
    readonly inviteValidity: {
        readonly isValid: boolean;
        readonly copyTitle: string;
        readonly copySubtext: string;
        readonly username: string | null;
        readonly invitationType: InvitationTypeEnum | null;
    };
};
export type InvitationAcceptanceFormTokenValidityQuery = {
    readonly response: InvitationAcceptanceFormTokenValidityQueryResponse;
    readonly variables: InvitationAcceptanceFormTokenValidityQueryVariables;
};



/*
query InvitationAcceptanceFormTokenValidityQuery(
  $token: String!
) {
  inviteValidity(token: $token) {
    isValid
    copyTitle
    copySubtext
    username
    invitationType
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "InviteValidationResponse",
    "kind": "LinkedField",
    "name": "inviteValidity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isValid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "copyTitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "copySubtext",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invitationType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvitationAcceptanceFormTokenValidityQuery",
    "selections": (v1/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvitationAcceptanceFormTokenValidityQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ce2a01091ebbe6419e0f8881548bee9b",
    "id": null,
    "metadata": {},
    "name": "InvitationAcceptanceFormTokenValidityQuery",
    "operationKind": "query",
    "text": "query InvitationAcceptanceFormTokenValidityQuery(\n  $token: String!\n) {\n  inviteValidity(token: $token) {\n    isValid\n    copyTitle\n    copySubtext\n    username\n    invitationType\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c2edb78656eb32b88849d9cf10c84bed';
export default node;
